import React, { useContext, useEffect } from 'react'
import { Container } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { GeneralContext } from '../../context/'
import MarialuisasManager from './components/MarialuisasManager'

const Index = () => {
    const { setBreadcrumb } = useContext(GeneralContext)

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: 'María Luisas',
            parentLink: '/marialuisas',
            item: 'María Luisas'
        })
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <MarialuisasManager />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Index)
